import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { CheckoutResolversActions } from './checkout-resolvers.actions';

export const platformCheckoutResolver: ResolveFn<object> = () => {
  const appSettings = inject(AppConfigSettings);
  const store = inject(Store);
  appSettings.setconfig('usePaymentLinkEndpoints', 'false');
  appSettings.setconfig('useHostedPaymentsPageEndpoints', 'false');
  appSettings.setconfig('disableSavePaymentAccount', 'false');
  appSettings.setconfig('disablePaymentDate', 'false');
  appSettings.setconfig('navigateOnStepChange', 'false');
  store.dispatch(
    CheckoutResolversActions.platformCheckoutResolved({
      disablePaymentDate: false,
    }),
  );
  return of({});
};
